import $ from 'jquery';
import {
  editorUndo,
  editorRedo,
  editorAddText,
  editorMoveObjectBackward,
  editorMoveObjectForward,
  onCloneObjects,
  onSaveCanvasBtnClick,
  onPrintCanvasBtnClick,
  onShareCanvasBtnClick,
  resetTextRotation,
  toggleObjectShadow,
  toggleTextBorder,
  toggleObjectEraser,
  adapt,
} from '~core';
import {
  editorSetTextAlign,
  toggleFontStlyeItalic,
  fontSizePlus,
  fontSizeMinus,
  toggleFontWeightBold,
  toggleTextUnderline,
} from '~core/text';
import { onLinkServizio } from '~core/navbar';
import { initAllSubmenus } from '~core/navbar/submenus';
import { toggleObjectLock, deleteObject, deselectObjects } from '~src/ui';
import { onTextBorderThicknessChange, removeTextBorder } from '~core/borders';
import { onTextBorderChangeColor } from '~src/sidebar/onTextBorderChangeColor';
import { initCropListeners } from '~src/crop';
import { initRemovebgListeners } from '~core/removebg';
import { initImageEnhancementListeners } from '~src/imageEnhancement';
import { initSmileListeners } from '~core/smile';
import { initColorizeListeners } from '~core/colorize';
import { initExpandListeners } from '~core/expand';
import { initMagicFrameEventListeners } from '~core/magicFrame';
import { initResizeListeners } from '~core/resizeImage';
import { initAiEditListeners } from '~core/aiEdit';
import { modifyState } from '~src/state';
import { startCloneStamp } from '~core/cloneStamp';
import { startMagicEraser } from '~core/magicEraser';
import { startChangeClothes } from '~core/changeClothes';
import { startDissolvenza } from '~core/dissolvenza';
import { handleBackgroundFusion } from '~core/backgroundFusion';
import { initMagicWand } from '~core/magicWand';
import { toggleRuler } from '~core/ruler';

export const addEditorMenuClickListeners = () => {
  $('#editor-menu-add-text').click(
    editorAddText.bind(null, 'HEADING', 'Titolo')
  );
  $('#editor-menu-text-bold').click(toggleFontWeightBold);
  $('#editor-menu-text-italic').click(toggleFontStlyeItalic);
  $('#editor-menu-font-size-plus').click(fontSizePlus);
  $('#editor-menu-font-size-minus').click(fontSizeMinus);
  $('#editor-menu-text-align-left').click(
    editorSetTextAlign.bind(null, 'left')
  );
  $('#editor-menu-text-align-center').click(
    editorSetTextAlign.bind(null, 'center')
  );
  $('#editor-menu-text-align-right').click(
    editorSetTextAlign.bind(null, 'right')
  );
  $('#editor-menu-text-align-justify').click(
    editorSetTextAlign.bind(null, 'justify')
  );
  $('#editor-menu-text-underline').click(toggleTextUnderline);
  $('#editor-menu-object-shadow').click(toggleObjectShadow);
  $('#editor-menu-text-border').click(toggleTextBorder);
  $('#editor-menu-object-eraser').click(toggleObjectEraser);
  $('#editor-menu-image-clone-stamp').click(
    startCloneStamp(window.CloneStamp.MODE_PROGRESSIVE)
  );
  // Use event delegation for dynamically rendered AI features
  $('body').on('click', '#editor-menu-image-magic-eraser', startMagicEraser);
  $('body').on(
    'click',
    '#editor-menu-image-change-clothes',
    startChangeClothes
  );
  $('body').on('click', '#editor-menu-image-dissolvenza', startDissolvenza);
  $('body').on(
    'click',
    '#editor-menu-image-background-fusion',
    handleBackgroundFusion
  );
  $('#editor-menu-image-smudge-stamp').click(
    startCloneStamp(window.CloneStamp.MODE_SMUDGE)
  );
  $('#editor-menu-elimina').click(deleteObject);
  $('#editor-menu-undo').click(editorUndo);
  $('#editor-menu-redo').click(editorRedo);
  $('#editor-menu-ruler').click(toggleRuler);
  $('#editor-menu-backward').click(editorMoveObjectBackward);
  $('#editor-menu-forward').click(editorMoveObjectForward);
  $('#editor-menu-salva').click(onSaveCanvasBtnClick);
  $('#editor-menu-print').click(onPrintCanvasBtnClick);
  $('#editor-menu-share').click(onShareCanvasBtnClick);
  $('#editor-menu-obj-clone').click(onCloneObjects);
  $('#editor-menu-lock').click(toggleObjectLock);
  $('#editor-menu-obj-reset-rotation').click(resetTextRotation);
  $('#editor-menu-obj-adapt').click(adapt);
  $('#editor-menu-remove-text-border').click(removeTextBorder);
  $('#editor-menu-text-border-color').click(onTextBorderChangeColor);

  // Text border thickness slider and input
  $('body').on(
    'input change',
    '#editor-text-border-thickness-slider, #editor-text-border-thickness-value',
    onTextBorderThicknessChange
  );

  $('body').on('click', '.linkServizio', onLinkServizio);

  $('body').on('focus', 'input', () => {
    modifyState('isFocusingOnInput', true);
  });

  $('body').on('focusout', 'input', () => {
    modifyState('isFocusingOnInput', false);
  });

  const excludedInputs = ['#input-filter-fonts'];
  ['input[type="search"]', 'input[type="text"]', '#qr-form-user-input'].forEach(
    (selector) => {
      $('body').on('keydown', selector, (el) => {
        if (
          excludedInputs.includes(selector) ||
          excludedInputs.includes(`#${el.currentTarget.id}`)
        ) {
          return;
        }
        modifyState('ignoreNextObjectDeselect', true);
        deselectObjects();
      });
    }
  );

  initAllSubmenus();
  initCropListeners();
  initRemovebgListeners();
  initImageEnhancementListeners();
  initMagicFrameEventListeners();
  initSmileListeners();
  initColorizeListeners();
  initExpandListeners();
  initResizeListeners();
  initAiEditListeners();
  initMagicWand();

  $(document).on('contextmenu', '.protected-image', function (e) {
    e.preventDefault();
    return false;
  });
};
